module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "containerMessage",
    style: ({
      'background-color': 'none'
    })
  }, [_c('ul', {
    staticClass: "ulMessageMenu"
  }, [_c('li', {
    staticClass: "liMessageMenu",
    class: _vm.optionClicked ? 'changeCursor ' + 'notselected' : 'selected',
    style: ({
      'height': '120px !important'
    })
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column",
    style: ({
      'margin-left': '35px'
    })
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[0].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.yes + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '10px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[0].optionName[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column",
    style: ({
      'margin-left': '60px'
    })
  }, [_c('a', {
    staticClass: "aSurveyMessage",
    class: _vm.optionClicked ? 'changeCursor' : '',
    on: {
      "click": function($event) {
        _vm.sendMessage(_vm.getObjectMenu(_vm.message.message)[1].option)
      }
    }
  }, [_c('div', {
    staticClass: "faces centrado",
    style: ({
      'background-image': 'url(' + _vm.no + ')',
      'top': '0px'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centrado",
    style: ({
      'font-size': '10px!important',
      'top': '50px'
    })
  }, [_vm._v(_vm._s(_vm.getObjectMenu(_vm.message.message)[1].optionName[0]))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec7d482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messageSurveyYesNo.vue
// module id = 407
// module chunks = 2